<jit-resource-card
  *ngFor="let resource of resources"
  [resource]="resource"
></jit-resource-card>
